import SETTINGS from "../../settings";
import { getSolarData } from "../../utils/mapping-functions";
import log from "loglevel";
const Lights = (props) => {
  const solarData = getSolarData(
    props.latitude,
    Math.floor(props.date * 365),
    props.time * 12 + 6 // 5am to 7pm. 14 hours.
  );
  const sunAltitude = Math.PI / 2 - solarData.solarZenith;
  const intensity = Math.sin(sunAltitude) / 2;
  const scale = props.size / SETTINGS.TERRAIN.SCALE;
  const sunColour = new THREE.Color(
    // 1,
    1 + Math.sin(solarData.solarZenith),
    1 + Math.sin(solarData.solarZenith),

    Math.min(Math.max(Math.sin(sunAltitude), 0.1), 0.9)
  );

  return (
    <>
      <hemisphereLight
        args={[0xdddddd, 0xdddddd, 1]}
        intensity={0.5}
        position={[0, 50, 0]}
      />
      <pointLight
        castShadow
        position={[
          scale * solarData.position.x,
          scale * solarData.position.z,
          scale * solarData.position.y,
        ]}
        intensity={intensity}
        color={sunColour}
      />
    </>
  );
};

export default React.memo(Lights);
